import { IParamsGetDiscountVoucher } from 'app/api/marketing/discount-voucher/model'

export const VoucherKeys = {
  allVouchers: ['Vouchers'] as const,
  listVoucher: () =>
    [...VoucherKeys.allVouchers, 'VouchersList'] as const,
  listVouchers: (filter?: IParamsGetDiscountVoucher) =>
    [...VoucherKeys.listVoucher(), { filter }] as const,
}
